import React, { useEffect, useMemo, useState } from "react";
import {
  ResultRowContainer,
  ResultHeader,
  ResultPanelStyle,
  ResultText,
  ResultFooter,
  ResultText2,
  TableContainer,
  TableStyled,
} from "./Result.styled";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { HideResultPanelAction, IApplicationState } from "../../store";
import { Icons, Text } from "@sede-enterprise/shell-ds-react-framework";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { BidProductTypeEnum } from "../../services";
import { useWindowSize } from "../../hooks/useWindowSize";
import { CellInfo } from "../../core/types";

const Result: React.FC = () => {
  const dispatch = useAppDispatch();
  const size = useWindowSize();

  const calculateMaxHeight = () => {
    return window.innerHeight - 200;
  };

  const calculateMaxWidth = () => {
    return window.innerWidth;
  };

  const [maxHeight, setMaxHeight] = useState(calculateMaxHeight());
  const [maxWidth, _] = useState(calculateMaxWidth());

  const auctions = useSelector((state: IApplicationState) => state.auction.data);
  const itaAuctionResult = useSelector((state: IApplicationState) => state.result.itaAuctionResult);

  const rowData = useMemo(
    () => itaAuctionResult?.results || [],
    [itaAuctionResult?.results]
  );

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(calculateMaxHeight());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const onClose = () => {
    return dispatch(HideResultPanelAction());
  };

  const renderValue = (value: any) => {
    return <div>{value}</div>;
  };

  const renderZkey = (value: any) => {
    if (value === "NA") return "Not Confirmed";
    else return value;
  };

  const renderProductHours = (value: any) => {
    const selectedAuction = auctions?.find(
      (auction) => auction.auctionName === itaAuctionResult?.auctionId
    );
    if (
      selectedAuction?.product === BidProductTypeEnum.Daily ||
      selectedAuction?.product === BidProductTypeEnum.Intraday
    ) {
      return <div>{value}</div>;
    } else {
      return <div>Every Day {value}</div>;
    }
  };
  const resultDetailsColumns = () => [
    {
      header: "Time",
      dataIndex: "productHour",
      accessorKey: "productHour",
      width: 120,
      cell: (info: CellInfo) => renderProductHours(info.getValue()),
    },
    {
      header: "Capacity Won",
      dataIndex: "capacityWon",
      accessorKey: "capacityWon",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Clearing Price",
      dataIndex: "offeredPrice",
      accessorKey: "offeredPrice",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
  ];

  return (
    <div data-testid="result">
      <ResultPanelStyle>
        <ResultHeader>
          <Text bold={true} size="large">
            {itaAuctionResult?.auctionId}
          </Text>
          <Icons.Cross className="crossIcon" onClick={onClose} />
        </ResultHeader>

        <ResultRowContainer>
          <ResultText>
            <Text bold={true} size="medium" id="zkey">
              Aligne ZKey :
            </Text>
          </ResultText>
          <ResultText2>
            <Text size="small" id="zkeyValue">
              {renderZkey(itaAuctionResult?.zkey)}
            </Text>
          </ResultText2>
        </ResultRowContainer>

        <ResultRowContainer>
          <ResultText>
            <Text bold={true} size="medium" id="uniqueResultsId">
              Exchange Results Id :
            </Text>
          </ResultText>
          <ResultText2>
            <Text size="small" id="uniqueResultsIdValue">
              {itaAuctionResult?.uniqueResultsId}
            </Text>
          </ResultText2>
        </ResultRowContainer>
        <ResultRowContainer>
          <ResultText>
            <Text bold={true} size="medium" id="book">
              Book :
            </Text>
          </ResultText>
          <ResultText2>
            <Text size="small" id="bookValue">
              {itaAuctionResult?.book}
            </Text>
          </ResultText2>
        </ResultRowContainer>
        <ResultRowContainer></ResultRowContainer>
        <TableContainer>
          <TableStyled
            data-testid="result-table"
            data={rowData}
            columns={resultDetailsColumns()}
            size="small"
            stickyHeader={true}
            maxHeight={maxHeight}
            maxWidth={maxWidth}
          />
        </TableContainer>
        <ResultFooter></ResultFooter>
      </ResultPanelStyle>
    </div>
  );
};
export default Result;
